export const getProductService = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/quickbooks/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getProductServiceList = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/quickbooks/products-services/${queryString ? `?${queryString}` : ''}`;
};

export const getProductServiceCompanyNamesApi = () => {
   return `integrations/quickbooks/company_name/?source=product_and_service`;
}